module.exports = __webpack_public_path__ + "media/images/thank-desktop-b6177eb0519642803348571de10e5805.jpg";